import { render, staticRenderFns } from "./appInfo.vue?vue&type=template&id=047bcb48&scoped=true"
import script from "./appInfo.vue?vue&type=script&lang=js"
export * from "./appInfo.vue?vue&type=script&lang=js"
import style0 from "./appInfo.vue?vue&type=style&index=0&id=047bcb48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047bcb48",
  null
  
)

export default component.exports